import React from "react";
import { Button, Typography } from "../components/common";

/**
 * Admin-console Trial-expired conversion-prompt page (Phase 3d).
 *
 * Same contract as the learner-app variant: triggered when the global
 * `installTrialExpiredHandler` interceptor sees a 403 with body
 * error_code=trial_expired from any protected backend surface.
 */
const SUPPORT_EMAIL = "support@pedagogue.io";
// Packaging simplification (2026-07-20): lockout CTA leads with the £4,995
// Whole-School AI Enablement Package invoice request (the £1,295 Leadership
// Package was scrapped; Calendly stays out of the funnel); fulfilment is
// manual via the Super-Admin convert-trial flow.
const INVOICE_SUBJECT = encodeURIComponent(
  "£4,995 Whole-School AI Enablement Package invoice request",
);

const TrialExpired: React.FC = () => {
  return (
    <main
      data-testid="trial-expired-page"
      className="flex min-h-screen items-center justify-center bg-slate-50 px-6"
    >
      <div className="w-full max-w-xl rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <Typography variant="h1" weight="bold" className="mb-3 text-slate-900">
          Your Pedagogue trial has ended
        </Typography>
        <Typography variant="p" className="mb-5 text-slate-700">
          Thanks for exploring Pedagogue. The trial for your
          organisation has finished, so admin access is now paused.
        </Typography>
        <Typography variant="p" className="mb-6 text-slate-700">
          To continue, request your{" "}
          <strong>£4,995 Whole-School AI Enablement Package invoice</strong>{" "}
          &mdash; email us and we&rsquo;ll set your whole school up with a full
          year of access.
        </Typography>
        <div className="flex flex-col gap-4 sm:flex-row">
          <Button
            onClick={() =>
              (window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${INVOICE_SUBJECT}`)
            }
            variant="filled"
            size="large"
          >
            Request your £4,995 Whole-School invoice
          </Button>
          <Button
            onClick={() =>
              (window.location.href = `mailto:${SUPPORT_EMAIL}?subject=Trial%20question`)
            }
            variant="outline"
            size="large"
          >
            Email {SUPPORT_EMAIL}
          </Button>
        </div>
      </div>
    </main>
  );
};

export default TrialExpired;
